import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const STORAGE_POINT_TYPES = {
   COMMERCIAL_NETWORK: 'COMMERCIAL_NETWORK',
   INTERNAL_STORAGE: 'INTERNAL_STORAGE',
   EXTERNAL_STORAGE: 'EXTERNAL_STORAGE',
} as const;

export const useStoragePointTypes = () => {
   const { t } = useTranslation();

   const storagePointTypes = useMemo(
      () => [
         {
            label: t('distribution_center.network'),
            value: STORAGE_POINT_TYPES.COMMERCIAL_NETWORK,
         },
         {
            label: t('storage_point_type.external_storage'),
            value: STORAGE_POINT_TYPES.EXTERNAL_STORAGE,
         },
         {
            label: t('storage_point_type.internal_storage'),
            value: STORAGE_POINT_TYPES.INTERNAL_STORAGE,
         },
      ],
      [t],
   );

   return { storagePointTypes };
};
